'use client';
import { useState, useEffect } from 'react';
import { useSession, signIn, signOut } from "next-auth/react";
import Image from 'next/image';
import { Button } from "@/components/ui/button";
import { 
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";

function getBrandingName(): string {
  if (typeof window !== "undefined") {
    const hostname = window.location.hostname;
    if (hostname.includes("quickstartapi.com")) return "QuickStartAPI";
  }
  return "MyInstantAPI";
}


export default function MainHeader() {
  const { data: session, status } = useSession();
  const [isMobile, setIsMobile] = useState(false);
  const [brandName, setBrandName] = useState("MyInstantAPI");

  useEffect(() => {
    setBrandName(getBrandingName());
    const checkMobile = () => {
      // Change breakpoint to 700px to match your current width
      const isMobileView = window.innerWidth < 700;
      console.log("Window width:", window.innerWidth);
      console.log("Is mobile?", isMobileView);
      setIsMobile(isMobileView);
    }
    
    // Run on mount
    checkMobile();
    
    // Add resize listener
    window.addEventListener('resize', checkMobile);
    
    // Cleanup
    return () => window.removeEventListener('resize', checkMobile);
  }, [])

  const handleSignIn = () => {
    // Track sign-in attempt
    window.gtag('event', 'login_attempt', {
      method: 'github',
      location: 'header'
    });
    
    signIn("github");
  };

  const handleSignOut = () => {
    // Track sign-out
    window.gtag('event', 'logout', {
      method: 'github'
    });
    
    signOut({ redirect: false });
  };

  return (
    <header className="flex items-center justify-between px-8 mb-6">
      <div className="flex items-center space-x-4">
        <Image src="/vercapi.svg" alt="Vercapi Logo" className="h-12 w-12" width="48" height="48" />
        <div>
          <h1 className="text-3xl font-bold tracking-tight">
            {brandName}
          </h1>
          <p className="text-lg text-muted-foreground" style={isMobile ? { fontSize: '15px' } : {}}>
            Securely host your APIs in seconds
          </p>
        </div>
      </div>
      
      <div>
        {status === "authenticated" && (
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button variant="ghost" className="relative h-8 w-8 rounded-full">
                <Avatar className="h-8 w-8">
                  <AvatarImage src={session.user?.image || ''} alt={session.user?.name || ''} />
                  <AvatarFallback>{session.user?.name?.[0] || 'U'}</AvatarFallback>
                </Avatar>
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end">
              <DropdownMenuItem className="text-sm">
                Signed in as {session.user?.email}
              </DropdownMenuItem>
              <DropdownMenuItem onClick={() => handleSignOut()}>
                Sign out
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        )}
        {status === "unauthenticated" && !isMobile && (
          <Button 
            onClick={() => handleSignIn()}
            className="inline-flex items-center"
            style={{backgroundColor:"#2563eb"}}
          >
            Sign in with GitHub
          </Button>
        )}
      </div>
    </header>
  );
}